var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 32 32"}},[_c('g',{staticClass:"fill-current",attrs:{"fill":_vm.color}},[_c('path',{attrs:{"d":"M6 4l20 12-20 12z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }